import { i18n } from 'src/boot/i18n'
import { del, get, patch, post, put } from 'src/helpers/api'
import { api } from '../api'
import {
  MEMBERSHIP_ROLE_LIST_ROLE_ROW_UPDATE,
  SET_DELIVERY_CHARGE_LIST_DATA,
  SET_FORM_DATA,
  SET_MASTER_DATA_LIST_DATA,
  SET_MASTER_DATA_OPTIONS,
  SET_MASTER_LIST_DATA,
  SET_MEMBERSHIP_ROLE_LIST_DATA,
  SET_MODULE_LIST_DATA,
  SET_MODULE_LIST_DATA_WITH_CHILDS,
  SET_MODULE_OPTIONS,
  SET_OPERATIONS_DATA,
  SET_REPORT_CONFIGS_LIST_DATA,
  SET_ROLE_GROUP_LIST,
  SET_ROLE_GROUP_LIST_WITH_CHILDS,
  SET_ROLES_LIST,
  SET_SETTINGS_ENROLLMENT_TYPE,
  SET_STAFF_LIST_DATA,
  SET_STATE_LIST_DATA,
  SET_CITY_LIST_DATA,
  SET_STOCK_LOCATION_LIST_DATA,
  SET_TAX_LIST_DATA,
  SET_USER_COUNTRY_LOCATIONS_DATA,
  SET_ZONE_LIST_DATA,
  SHOW_NOTIFICATION,
  SET_ROLE_GROUP_DATA,
  SET_DEPARTMENT_LIST_DATA,
  SET_DEPARTMENT_OPTIONS,
  SET_LOCATIONS_OPTIONS,
  SET_CURRENCIES_LIST_DATA,
  SET_CURRENCIES_CONVERSIONS_LIST_DATA,
} from 'src/store/types'
import _ from 'lodash'

export const loadModuleDataByIdAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.modules + '/' + id).then(response => {
      const json = response.data
      // Simple hack to change switch state active or inactive
      // Since element ui v-model expecting true:false but API return 1:0
      // TODO Find optimal solutions
      json.active = !!json.active
      if (json.parent_id === 0) {
        json.parent_id = ''
      }
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}

export const createModuleAction = ({ commit }, data) => {
  return new Promise(resolve => {
    // Remove if parent not selected to avoid validation error
    if (data.parent_id === '') {
      delete data.parent_id
    }
    post(api.modules, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create Module', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const updateModuleAction = ({ commit }, data) => {
  return new Promise(resolve => {
    // Replace parent_id to 0 before save reason field set as NULL no UNSIGNED
    if (data.parent_id === '') {
      data.parent_id = 0
    }
    patch(api.modules + '/' + data.id, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Module', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}

export const deleteModuleAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.modules + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete Module', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}

export const getOptionsAction = ({ commit }) => {
  return new Promise(resolve => {
    get(api.modules).then(response => {
      const json = response.data.data
      commit(SET_MODULE_OPTIONS, {
        options: json.map(opt => ({ label: opt.label, value: opt.id })),
      })
      resolve(response.data)
    })
  })
}

export const getOperationsAction = ({ commit }) => {
  return new Promise(resolve => {
    get(api.operations).then(response => {
      const json = response.data.data
      commit(SET_OPERATIONS_DATA, {
        options: json.map(opt => ({ label: opt.name, value: opt.id })),
      })
      resolve(response.data)
    })
  })
}

export const getModuleListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.modulesList, query).then(response => {
      const json = response.data
      commit(SET_MODULE_LIST_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const loadRoleGroupDataByIdAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.rolesGroup + '/' + id).then(response => {
      const json = response.data
      if (json.parent_id === 0) {
        json.parent_id = ''
      }
      commit(SET_ROLE_GROUP_DATA, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const createRoleGroupAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.rolesGroup, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create Role Group', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const updateRoleGroupAction = ({ commit }, data) => {
  return new Promise(resolve => {
    put(api.rolesGroup + '/' + data.id, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Role Group', message: 'Operation success', type: 'positive' })
      const json = response.data
      if (json.parent_id === 0) {
        json.parent_id = ''
      }
      commit(SET_ROLE_GROUP_DATA, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const deleteRoleGroupAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.rolesGroup + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete Role Group', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const getRoleGroupListAction = ({ commit }, query = '') => {
  return new Promise(resolve => {
    get(api.rolesGroup + query).then(response => {
      const json = response.data
      commit(SET_ROLE_GROUP_LIST, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const getAllRoleGroupAction = ({ commit }) => {
  return new Promise(resolve => {
    get(api.rolesGroup).then(response => {
      let groupByUserType = _.chain(response.data.data)
        .groupBy(function(item) {
          return item.user_type.name
        })
        .toPairs()
        .map(item => _.zipObject(['label', 'options'], item))
        .value()
      commit(SET_ROLE_GROUP_LIST_WITH_CHILDS, {
        list: groupByUserType,
      })

      resolve(response.data)
    })
  })
}

export const getAllModuleListAction = ({ commit }) => {
  return new Promise(resolve => {
    get(api.modules).then(response => {
      const json = response.data
      commit(SET_MODULE_LIST_DATA_WITH_CHILDS, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const getRolesListAction = ({ commit }, query = '') => {
  return new Promise(resolve => {
    get(api.roles + query).then(response => {
      const json = response.data
      commit(SET_ROLES_LIST, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const roleBuilderAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.roles, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create Role', message: 'Operation success', type: 'positive' })
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })
      resolve(response.data)
    })
  })
}

export const roleBuilderUpdateAction = ({ commit }, data) => {
  return new Promise(resolve => {
    put(api.roles + '/' + data.id, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Role', message: 'Operation success', type: 'positive' })
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })
      resolve(response.data)
    })
  })
}

export const loadRoleDataByIdAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.roles + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })
      resolve(response.data)
    })
  })
}

// Master
export const loadMasterByIdAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.masters + '/' + id).then(response => {
      const json = response.data
      // Simple hack to change switch state active or inactive
      // Since element ui v-model expecting true:false but API return 1:0
      json.active = Boolean(Number(json.active))
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}

export const createMasterAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.masters, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create Master', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const updateMasterAction = ({ commit }, data) => {
  return new Promise(resolve => {
    put(api.masters + '/' + data.id, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Master', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}

export const deleteMasterAction = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    del(api.masters + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete Master', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}

export const getMasterListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.masters + '?' + query).then(response => {
      const json = response.data
      commit(SET_MASTER_LIST_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

// Master Data
export const getMasterDataListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.mastersData + '?' + query).then(response => {
      const json = response.data
      commit(SET_MASTER_DATA_LIST_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const getMasterDataOptionsAction = ({ commit }) => {
  return new Promise(resolve => {
    get(api.masters).then(response => {
      const json = response.data.data
      commit(SET_MASTER_DATA_OPTIONS, {
        options: json.map(opt => ({ label: opt.title, value: opt.id })),
      })
      resolve(response.data)
    })
  })
}

export const loadMasterDataByIdAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.mastersData + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}

export const createMasterDataAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.mastersData, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create Master Data', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const updateMasterDataAction = ({ commit }, data) => {
  return new Promise(resolve => {
    put(api.mastersData + '/' + data.id, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Master Data', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}

export const deleteMasterDataAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.mastersData + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete Master Data', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}

export const createStaffAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.staff, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create User', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const updateUserAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.userPrivileges, data).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })
      commit(SHOW_NOTIFICATION, { title: 'Update User', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}

export const loadUserByIdAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.userPrivileges + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}

export const getUsersListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.usersList, query).then(response => {
      const json = response.data
      commit(SET_STAFF_LIST_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const loadUserLocationsByIdAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.userLocations + '/' + id).then(response => {
      const json = response.data
      commit(SET_USER_COUNTRY_LOCATIONS_DATA, {
        data: json.data,
      })

      resolve(response.data)
    })
  })
}

export const getStateListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stateList, query).then(response => {
      const json = response.data
      commit(SET_STATE_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getCityListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.cityList, query).then(response => {
      const json = response.data
      commit(SET_CITY_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getStockLocationListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockLocationList, query).then(response => {
      const json = response.data
      commit(SET_STOCK_LOCATION_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getZoneListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.zoneList, query).then(response => {
      const json = response.data
      commit(SET_ZONE_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getZoneAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.zone + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}

export const createZoneAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.zone, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create Zone', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const updateZoneAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.zone, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Zone', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}

export const deleteZoneAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.zone + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete Zone', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}

export const getTaxListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.taxList, query).then(response => {
      const json = response.data
      commit(SET_TAX_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getTaxAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.tax + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}

export const createTaxAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.tax, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create Tax', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const updateTaxAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.tax, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Tax', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}

export const deleteTaxAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.tax + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete Tax', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}

export const getDeliveryChargeListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.deliveryChargeList, query).then(response => {
      const json = response.data
      commit(SET_DELIVERY_CHARGE_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getDeliveryChargeAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.deliveryCharge + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}

export const createDeliveryChargeAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.deliveryCharge, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Create Delivery Charge', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const updateDeliveryChargeAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.deliveryCharge, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Delivery Charge', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}

export const deleteDeliveryChargeAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.deliveryCharge + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Delete Delivery Charge', message: 'Operation success', type: 'info' })
      resolve(response.data)
    })
  })
}

export const getReportConfigsListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.reportConfigsList, query).then(response => {
      const json = response.data
      commit(SET_REPORT_CONFIGS_LIST_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const createUpdateDeleteReportConfigAction = ({ commit }, data) => {
  return new Promise(resolve => {
    if (data.type === 'update') {
      put(api.reportConfig + '/' + data.configID, data.years).then(response => {
        const json = response.data[0]
        commit(SET_FORM_DATA, {
          formData: json,
        })
        commit(SHOW_NOTIFICATION, { title: 'Update Report Config', message: 'Operation success', type: 'positive' })
        resolve(response.data)
      })
    } else if (data.type === 'view') {
      get(api.reportConfig + '/' + data.configID).then(response => {
        const json = response.data
        commit(SET_FORM_DATA, {
          formData: json,
        })
        resolve(response.data)
      })
    } else if (data.type === 'delete') {
      del(api.reportConfig + '/' + data.configID).then(response => {
        commit(SHOW_NOTIFICATION, {
          title: 'Report Config Year Deleted',
          message: 'Operation success',
          type: 'positive',
        })
        resolve(response.data)
      })
    } else {
      post(api.reportConfig, data).then(response => {
        commit(SHOW_NOTIFICATION, { title: 'Create Report Config', message: 'Operation success', type: 'positive' })
        resolve(response.data)
      })
    }
  })
}

export const attachReportsToRole = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.attachReportsToRole, query).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Assign Reports Permissions', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const getEnrollmentTypeByConditionIdAction = ({ commit }, conditionID = '') => {
  return new Promise(resolve => {
    get(api.enrollmentTypeByCondition + conditionID).then(response => {
      commit(SET_SETTINGS_ENROLLMENT_TYPE, response.data)
      resolve(response.data)
    })
  })
}

export const getAllMembershipRoleListAction = ({ commit }, query = '') => {
  return new Promise(resolve => {
    get(api.membershipRole + query).then(response => {
      const json = response.data
      commit(SET_MEMBERSHIP_ROLE_LIST_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const updateMembershipRoleListRoleRowAction = ({ commit }, payload) => {
  return new Promise(resolve => {
    commit(MEMBERSHIP_ROLE_LIST_ROLE_ROW_UPDATE, payload)

    resolve(true)
  })
}

export const loadMembershipRoleByIdAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.membershipRole + '/' + id).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}

export const createMembershipRoleByIdAction = ({ commit }, payload) => {
  return new Promise(resolve => {
    post(api.membershipRole, payload).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}

export const updateMembershipRoleByIdAction = ({ dispatch, commit }, payload) => {
  return new Promise(resolve => {
    put(api.membershipRole + '/' + payload.id, payload).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })

      resolve(response.data)
    })
  })
}

export const getDepartmentListAction = ({ commit }, payload = {}) => {
  return new Promise(resolve => {
    get(api.department, payload).then(response => {
      const json = response.data
      commit(SET_DEPARTMENT_LIST_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const createDepartmentAction = ({ commit }, data) => {
  return new Promise(resolve => {
    // Remove if parent not selected to avoid validation error
    if (data.parent_id === '') {
      delete data.parent_id
    }
    post(api.department, data).then(response => {
      commit(SHOW_NOTIFICATION, {
        title: i18n.t('modules.settings.department.createDepartment.operation.success.title'),
        message: i18n.t('modules.settings.department.createDepartment.operation.success.message'),
        type: 'positive',
      })
      resolve(response.data)
    })
  })
}

export const updateDepartmentAction = ({ commit }, data) => {
  return new Promise(resolve => {
    // Replace parent_id to 0 before save reason field set as NULL no UNSIGNED
    if (data.parent_id === '') {
      data.parent_id = 0
    }
    put(api.department + '/' + data.id, data).then(response => {
      commit(SHOW_NOTIFICATION, {
        title: i18n.t('modules.settings.department.updateDepartment.operation.success.title'),
        message: i18n.t('modules.settings.department.updateDepartment.operation.success.message'),
        type: 'positive',
      })
      resolve(response.data)
    })
  })
}

export const deleteDepartmentAction = ({ commit }, id) => {
  return new Promise(resolve => {
    del(api.department + '/' + id).then(response => {
      commit(SHOW_NOTIFICATION, {
        title: i18n.t('modules.settings.department.deleteDepartment.operation.delete.title'),
        message: i18n.t('modules.settings.department.deleteDepartment.operation.delete.message'),
        type: 'positive',
      })
      resolve(response.data)
    })
  })
}

export const loadDepartmentDataByIdAction = ({ commit }, data) => {
  return new Promise(resolve => {
    get(api.department + '/' + data.id + '?' + data.query).then(response => {
      const json = response.data
      commit(SET_FORM_DATA, {
        formData: json,
      })
      resolve(response.data)
    })
  })
}

export const getDepartmentOptionsAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.department + '?' + query).then(response => {
      const json = response.data.data
      commit(SET_DEPARTMENT_OPTIONS, {
        options: json.map(opt => ({ label: opt.name, value: opt.id })),
      })
      resolve(response.data)
    })
  })
}

export const getLocationsOptionsAction = ({ commit }) => {
  return new Promise(resolve => {
    get(api.locations).then(response => {
      const json = response.data.data
      commit(SET_LOCATIONS_OPTIONS, {
        options: json.map(opt => ({ label: opt.name, value: opt.id, sublabel: opt.code })),
      })
      resolve(response.data)
    })
  })
}

export const getCurrencyListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.currencies).then(response => {
      const json = response.data
      commit(SET_CURRENCIES_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const postCurrencyConversionAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.currenciesConversionPost, query).then(response => {
      const json = response.data
      resolve(response.data)
    })
  })
}

export const getCurrencyConversionListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.currenciesConversion, query).then(response => {
      const json = response.data
      commit(SET_CURRENCIES_CONVERSIONS_LIST_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}
